const mandatoryFields = ['sector_id', 'seat_group_id', 'row', 'num'];
export default mandatoryFields;
